import Card from '../../shared/Card';
import Header from '../../shared/Header';
import { Stack, Box, Flex } from '../../shared/layouts';
import FileAttachmentButton from '../../shared/FileAttachmentButton';
import {useTranslation} from "react-i18next";
import AdvisorDetails from '../../shared/AdvisorDetails';

const ServiceCard = ({
  service: { uuid, name, amount, payment_method, payment_status, end_date, advisor = {} },
  isMinDesktop,
  connectedFiles,
}) => {
  const { t } = useTranslation();
  const serviceFiles = connectedFiles?.[uuid] || [];

  return (
    <Card fontSize={isMinDesktop ? 'm' : 's'}>
      <Stack space={isMinDesktop ? 'l' : 'm'}>
        <Header
          title={name || t('Dienst')}
          variant="section"
          fontSize={isMinDesktop ? 'l' : 's'}
        />
        <div>
          <b>Details:</b>
          <Flex
            justifyContent={'space-between'}
            alignItems={'center'}
            height={'52px'}
            py={'m'}
            fontScale={'s'}
            borderBottom={'default'}
          >
            <Box flex="35% 1 0">{t('Bedrag: {{amount}}', {amount})}</Box>
            <Box flex="30% 1 0">{t('Betaalwijze: {{method}}', {method: payment_method})}</Box>
            <Box flex="30% 0 0">
              {end_date
                ? t('Einddatum: {{date}}', {date: end_date})
                : t('Betaalstatus: {{status}}', {status: payment_status})}
            </Box>
          </Flex>
        </div>
        {serviceFiles?.length > 0 && (
          <div>
            <b>Document(en):</b>
            <Stack space={'s'} mt={'s'}>
              {serviceFiles.map(({ name, download_url }) => (
                <FileAttachmentButton
                  key={name}
                  fileName={name}
                  fileUrl={download_url}
                />
              ))}
            </Stack>
          </div>
        )}
        {Object.keys(advisor).length > 0 && <AdvisorDetails {...advisor} />}
      </Stack>
    </Card>
  );
};

export default ServiceCard;
